import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Childcare_expenses_2_@2x.png'
import _imports_1 from '@/assets/images/Relationship_status_2_.png'
import _imports_2 from '@/assets/images/Contract_of_carriage_1_.png'


const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold mb-30" }, "ACA Mandate Related Reports", -1)
const _hoisted_3 = {
  key: 1,
  class: "d-flex gap-15 flex-md-row flex-column"
}
const _hoisted_4 = { class: "bordered-card bordered-card_tertiary justify-content-between pdt-25 pdb-25 gap-25 flex-row" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start gap-10 flex-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-medium" }, "Request Employee Health Coverage Date ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow fs-lg" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "90",
  height: "89",
  alt: "Childcare expenses"
}, null, -1)
const _hoisted_9 = { class: "bordered-card bordered-card_tertiary justify-content-between pdt-25 pdb-25 gap-25 flex-row" }
const _hoisted_10 = { class: "d-flex flex-column align-items-start gap-10 flex-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-medium" }, "Download requested Health coverage Data", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow fs-lg" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "83",
  height: "89",
  alt: "Relationship status"
}, null, -1)
const _hoisted_14 = { class: "bordered-card bordered-card_tertiary justify-content-between pdt-25 pdb-25 gap-25 flex-row" }
const _hoisted_15 = { class: "d-flex flex-column align-items-start gap-10 flex-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-medium" }, "Information about ACA Mandate ", -1)
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow fs-lg" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "95",
  height: "89",
  alt: "Contract of carriage"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", {
                class: "text-primary plan-modal d-flex gap-10 align-items-center",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '0' })), ["prevent"]))
              }, [
                _createTextVNode(" Request "),
                _hoisted_7
              ])
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", {
                class: "text-primary plan-modal d-flex gap-10 align-items-center",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('employer-aca-report', 'Employee Health Coverage Information Request', null, null, null, null, null, { download: '1' })), ["prevent"]))
              }, [
                _createTextVNode(" Download "),
                _hoisted_12
              ])
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("a", {
                href: _ctx.pdf,
                target: "_blank",
                class: "text-primary d-flex gap-10 align-items-center"
              }, [
                _createTextVNode(" See Information "),
                _hoisted_18
              ], 8, _hoisted_17)
            ]),
            _hoisted_19
          ])
        ]))
  ]))
}